"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimestamp = exports.dateToHHMM = exports.changeSecondsToMinutesFormat = exports.changeSecondsToDisplayFormat = exports.getTimeUntilDate = exports.getDaysUntilNextBill = exports.changeSelectedMonthFormatToDisplayFormat = exports.getVerboseDate = exports.changeUrlFormatToServerFormat = exports.changeUrlFormatToFrontFormat = exports.changeFrontFormatToShortFrontFormat = exports.changeFrontFormatToUrlFormat = exports.changeFrontFormatToServerFormat = exports.changeServerFormatToFrontFormat = exports.getActualDateString = exports.getMonthShortName = exports.getMonthId = exports.expirationDateCheck = exports.getNextYears = exports.getYear = exports.getMonthNumber = exports.getMonthNameByMonthId = exports.getMonthName = exports.lastDayOfMonth = exports.addYearToDate = exports.addMonthsToDate = exports.addOneMonthToDate = exports.getActualDate = exports.getJustDateFromDateTime = exports.changeDashFormatToSlash = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var URLFORMAT = 'DDMMYYYY';
var FRONTFORMAT = 'DD/MM/YYYY';
var SHORTFRONTFORMAT = 'DD/MM';
var SERVERFORMAT = 'YYYY-MM-DD';
var USAGESFORMAT = 'DD-MM-YYYY';

_moment["default"].locale('es');
/** Replaces - for /
  * @param {string} dateString Date string
  * @returns {string} Date with / instead of -
*/


var changeDashFormatToSlash = function changeDashFormatToSlash(dateString) {
  return dateString.replace(/-/g, '/');
};
/** Replaces - for /
  * @param {string} dateString Date string with front format
  * @returns {string} Date with format "10 de mayo"
*/


exports.changeDashFormatToSlash = changeDashFormatToSlash;

var getJustDateFromDateTime = function getJustDateFromDateTime(dateTime) {
  var dateString = dateTime.split(' ')[0];
  return "".concat((0, _moment["default"])(dateString, USAGESFORMAT).format('D'), " de ").concat((0, _moment["default"])(dateString, USAGESFORMAT).format('MMMM'));
};
/** Gets actual date
  * @returns {string} Actual date
*/


exports.getJustDateFromDateTime = getJustDateFromDateTime;

var getActualDate = function getActualDate() {
  return (0, _moment["default"])();
};
/** Add one month to the dateString pass as argument
  * @param {string} dateString Date string with front format
  * @returns {string} New dateString
*/


exports.getActualDate = getActualDate;

var addOneMonthToDate = function addOneMonthToDate(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).add(1, 'M').format(FRONTFORMAT);
};
/** Add the received number of months to the dateString pass as argument
  * @param {string} dateString Date string with front format
  * @param {number} months Number of months to add
  * @returns {string} New dateString
*/


exports.addOneMonthToDate = addOneMonthToDate;

var addMonthsToDate = function addMonthsToDate(dateString, months) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).add(months, 'M').format(FRONTFORMAT);
};
/** Add the received number of years to the dateString pass as argument
  * @param {string} dateString Date string with front format
  * @param {number} months Number of years to add
  * @returns {string} New dateString
*/


exports.addMonthsToDate = addMonthsToDate;

var addYearToDate = function addYearToDate(dateString, years) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).add(years, 'Y').format(FRONTFORMAT);
};
/** Transform the received dataString to the last day of his month
  * @param {string} dateString Date string with front format
  * @returns {string} New dateString
*/


exports.addYearToDate = addYearToDate;

var lastDayOfMonth = function lastDayOfMonth(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).endOf('month').format(FRONTFORMAT);
};
/** Gets the name of the month of the param
  * @param {string} dateString Date string with front format
  * @returns {string} Month name
*/


exports.lastDayOfMonth = lastDayOfMonth;

var getMonthName = function getMonthName(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format('MMMM');
};
/** Gets the name of the month of the param
  * @param {string} monthId month id with format YYYYMM
  * @returns {string} Month name
*/


exports.getMonthName = getMonthName;

var getMonthNameByMonthId = function getMonthNameByMonthId(dateString) {
  return (0, _moment["default"])(dateString, 'YYYYMM').format('MMMM');
};
/** Gets the number of the month of the param
  * @param {string} dateString Date string with front format
  * @returns {string} Month number
*/


exports.getMonthNameByMonthId = getMonthNameByMonthId;

var getMonthNumber = function getMonthNumber(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format('MM');
};
/** Gets the year of the param
  * @param {string} dateString Date string with front format
  * @returns {string} Year
*/


exports.getMonthNumber = getMonthNumber;

var getYear = function getYear(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format('YYYY');
};
/** Retrieves the numbers of the years from the dateString
  * received to the number of years received
  * @param {string} dateString Date string with front format
  * @param {number} months Number of years to retrieve
  * @returns {string} New dateString
*/


exports.getYear = getYear;

var getNextYears = function getNextYears(dateString, years) {
  var nextYears = [];

  for (var i = 0; i < years; i += 1) {
    nextYears.push(getYear(addYearToDate(dateString, i)));
  }

  return nextYears;
};
/** Check if the received expirationDate is before of ActualDate
  * @param {Date} dateString Date string with front format
  * @returns {bool} Boolean value
*/


exports.getNextYears = getNextYears;

var expirationDateCheck = function expirationDateCheck(dateString) {
  var actualDate = getActualDate();
  var expDate = (0, _moment["default"])(dateString, FRONTFORMAT).endOf('day');
  return actualDate.isBefore(expDate);
};
/** Transforms the date of the param to obtain the key of the bills array
  * @param {string} dateString Date string with front format
  * @returns {string} Bill array's key
*/


exports.expirationDateCheck = expirationDateCheck;

var getMonthId = function getMonthId(dateString) {
  if (!dateString) {
    var now = (0, _moment["default"])().format(FRONTFORMAT);
    return getYear(now) + getMonthNumber(now);
  }

  return getYear(dateString) + getMonthNumber(dateString);
};
/** Gets the short name of the month indicated in the param
  * @param {string} dateString Date string with front format
  * @returns {string} Short month's name
*/


exports.getMonthId = getMonthId;

var getMonthShortName = function getMonthShortName(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format('MMM').replace('.', '');
};
/** Gets the actual date as string
  * @returns {string} Salute according to daytime
*/


exports.getMonthShortName = getMonthShortName;

var getActualDateString = function getActualDateString() {
  return (0, _moment["default"])().format(FRONTFORMAT).toString();
};
/** Changes the date from server format to front format
  * @param {string} dateString Date string with server format
  * @returns {string} Date string with front format
*/


exports.getActualDateString = getActualDateString;

var changeServerFormatToFrontFormat = function changeServerFormatToFrontFormat(dateString) {
  return (0, _moment["default"])(dateString, SERVERFORMAT).format(FRONTFORMAT);
};
/** Changes the date from front format to server format
  * @param {string} dateString Date string with front format
  * @returns {string} Date string with server format
*/


exports.changeServerFormatToFrontFormat = changeServerFormatToFrontFormat;

var changeFrontFormatToServerFormat = function changeFrontFormatToServerFormat(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format(SERVERFORMAT);
};
/** Changes the date from front format to URL format
  * @param {string} dateString Date string with front format
  * @returns {string} Date string with URL format
*/


exports.changeFrontFormatToServerFormat = changeFrontFormatToServerFormat;

var changeFrontFormatToUrlFormat = function changeFrontFormatToUrlFormat(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format(URLFORMAT);
};
/** Changes the date from front format to short front format
  * @param {string} dateString Date string with front format
  * @returns {string} Date string with short front format
*/


exports.changeFrontFormatToUrlFormat = changeFrontFormatToUrlFormat;

var changeFrontFormatToShortFrontFormat = function changeFrontFormatToShortFrontFormat(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format(SHORTFRONTFORMAT);
};
/** Changes the date from URL format to front format
  * @param {string} dateString Date string with URL format
  * @returns {string} Date string with front format
*/


exports.changeFrontFormatToShortFrontFormat = changeFrontFormatToShortFrontFormat;

var changeUrlFormatToFrontFormat = function changeUrlFormatToFrontFormat(dateString) {
  return (0, _moment["default"])(dateString, URLFORMAT).format(FRONTFORMAT);
};
/** Changes the date from URL format to server format
  * @param {string} dateString Date string with server format
  * @returns {string} Date string with front format
*/


exports.changeUrlFormatToFrontFormat = changeUrlFormatToFrontFormat;

var changeUrlFormatToServerFormat = function changeUrlFormatToServerFormat(dateString) {
  return (0, _moment["default"])(dateString, URLFORMAT).format(SERVERFORMAT);
};
/** Create a date string with the format (25 de Jul. 2018)
  * @param {string} dateString Date string with front format
  * @returns {string} Date string with "25 de Jul. 2018" format
*/


exports.changeUrlFormatToServerFormat = changeUrlFormatToServerFormat;

var getVerboseDate = function getVerboseDate(dateString) {
  return "".concat((0, _moment["default"])(dateString, FRONTFORMAT).format('D'), " de ").concat((0, _moment["default"])(dateString, FRONTFORMAT).format('MMM YYYY'));
};
/** Create a date string with the format (Julio 2018)
  * @param {string} dateString Date string with front format
  * @returns {string} Date string with "Julio 2018" format
*/


exports.getVerboseDate = getVerboseDate;

var changeSelectedMonthFormatToDisplayFormat = function changeSelectedMonthFormatToDisplayFormat(dateString) {
  return (0, _moment["default"])(dateString, FRONTFORMAT).format('MMMM YYYY')[0].toUpperCase() + (0, _moment["default"])(dateString, FRONTFORMAT).format('MMMM YYYY').slice(1);
};
/** Gets the days left for next bill
  * @param {string} dateString Date string
  * @returns {string} Remaining days for next bill
*/


exports.changeSelectedMonthFormatToDisplayFormat = changeSelectedMonthFormatToDisplayFormat;

var getDaysUntilNextBill = function getDaysUntilNextBill(dateString) {
  return (0, _moment["default"])(dateString).add(1, 'months') > (0, _moment["default"])() ? " estar\xE1 disponible ".concat((0, _moment["default"])().to((0, _moment["default"])(dateString, FRONTFORMAT).add(1, 'months')), ".") : 'aún no está disponible.';
};
/** Gets the days left for received date
  * @param {string} dateString Date string
  * @returns {string} Remaining days left until received date
*/


exports.getDaysUntilNextBill = getDaysUntilNextBill;

var getTimeUntilDate = function getTimeUntilDate(dateString) {
  var withoutPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _moment["default"])().to((0, _moment["default"])(dateString, FRONTFORMAT), withoutPrefix);
};
/** Changes seconds format
  * @param {string} secondString Seconds string
  * @returns {string} Seconds
*/


exports.getTimeUntilDate = getTimeUntilDate;

var changeSecondsToDisplayFormat = function changeSecondsToDisplayFormat(seconds) {
  var minutes = parseInt(seconds / 60, 10);
  var strReturned = "".concat(minutes, " min");
  return strReturned;
};

exports.changeSecondsToDisplayFormat = changeSecondsToDisplayFormat;

var changeSecondsToMinutesFormat = function changeSecondsToMinutesFormat(seconds) {
  var formatted = _moment["default"].utc(seconds * 1000).format('HH:mm:ss');

  var res = formatted.split(':');
  var hours = res[0];
  var min = res[1];
  var seg = res[2];
  var strReturned = hours > 0 ? "".concat(hours, " h ").concat(min, " min ").concat(seg, " seg") : "".concat(min, " min ").concat(seg, " seg");
  return strReturned;
};

exports.changeSecondsToMinutesFormat = changeSecondsToMinutesFormat;

var dateToHHMM = function dateToHHMM(date) {
  return (0, _moment["default"])(date).format('hh:mm');
};

exports.dateToHHMM = dateToHHMM;

var getTimestamp = function getTimestamp() {
  return (0, _moment["default"])().unix();
};

exports.getTimestamp = getTimestamp;

//# sourceMappingURL=index.js.map